import React, { useState } from 'react'
import ComponentMap from '../componentmap';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const MultiCheckBoxDropDown = (props: any) => {
  const { data, node, change } = props
  /**states */
  const [openDropdown, setOpenDropDown] = useState(false)

  const handleChange = (list: any) => {
    console.log("reachedddd", list);
    node.value = list.filter((node: any, index: any) => {
      return node.value === true
    })
    console.log("reacheddddeeeeee", node.value);
    // change(...list);
    let tempData: any = [...data];
    tempData.options = list;

    console.log(" tempData.options", tempData.options)
    change([...tempData])
  }
  console.log("nodebaladlsdn", node?.value)
  return (
    <div className='w-fit ml-auto mr-4 relative mt-1.5 flex flex-col items-end gap-1.5'>
      <div onClick={() => setOpenDropDown(!openDropdown)} className=' cursor-pointer w-[231px] px-3 py-1 rounded-md border border-primary-alpha-50 flex items-center justify-between'>
        <span className=' font-light leading-7'>{`${node.title}(${node.value?.filter((node: { hidden: boolean }) => !node?.hidden).length})`}</span>
        {openDropdown ?
          <KeyboardArrowDownIcon /> :
          <KeyboardArrowUpIcon />
        }
      </div>
      {openDropdown &&
        <div className={`w-[254px] pl-2.5  duration-200 z-10 absolute top-10 bg-[#ffffff] dark:bg-[#1e384b9c] dark:text-[white] backdrop-blur-lg rounded-md shadow-[0px_4px_4px_0px_rgba(0,0,0,0.10)]`}>
          <ComponentMap data={node.options} setData={handleChange} />
        </div>
      }
    </div>
  )
}

export default MultiCheckBoxDropDown